// 生成各个页面需要的空对象

// ======================================================== Gift

export const emptyApplyGuildForm = function () {
  let empty = {
    guildName: null,
    guildLogo: null,
    inviteCode: null,
    guildContacts: null,
    guildContactsPhone: null,
    // code:null,
    guildAdminId: null,
    guildAdminWhatsApp: null,
    guildAdminUserLang: [],
    guildAdminCardJustPic:null,
    anchorCountry:[],
    anchorNum: null,
    cooperationPlatform: null,
    monthFlow: null,
    email: null
  }
  return empty
}



// WEBPACK FOOTER //
// ./src/utils/empty-model.js